import { IRootState } from '../../../store'
import { IVitalOptionsState } from '../store/options.types'

export const getVitalOptionsSelector = (state: IRootState): IVitalOptionsState => state.options.vitalOptions
